<template lang="pug">
.block

    .field.mb-4
        label.block.text-sm.font-bold.mb-2(for="field") Field
        input.field-style(id="field" type="text" placeholder="Placeholder")
        
    .field.field--error.mb-4
        label.block.text-sm.font-bold.mb-2(for="fieldError") Field Error!
        input.field-style(id="fieldError" type="text" placeholder="Placeholder" value="Something error!")
        span.block.text-sm.mt-2 this is error message!

    .field.mb-4
        label.block.text-sm.font-bold.mb-2(for="fieldSelect") Field Select
        .relative
            select.field-style
                option Opstion A
                option Opstion B
                option Opstion C
                option Opstion D
            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
    //- input
    .field.field--disabled.mb-4
        label.block.text-sm.font-bold.mb-2(for="field") Field disabled
        input.field-style(id="field" type="text" placeholder="Placeholder" disabled value="Disabled Value")
    
    //- checkbox
    .field.field--checkbox.mb-4
        label.block.text-sm.font-bold.mb-2(for="field") Checkbox
        .wrapper-checkbox
            input(type="checkbox")
            .ui-checkbox.flex.items-center
                .checkbox.flex.items-center.justify-center
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                strong checkbox 
    
    .field.field--checkbox.mb-4
        .wrapper-checkbox.wrapper-checkbox--disabled
            input(type="checkbox" disabled)
            .ui-checkbox.flex.items-center
                .checkbox.flex.items-center.justify-center
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                strong checkbox disabled
    
    .field.field--checkbox.mb-4
        .wrapper-checkbox.wrapper-checkbox--disabled
            input(type="checkbox" disabled checked)
            .ui-checkbox.flex.items-center
                .checkbox.flex.items-center.justify-center
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                strong checkbox checked disabled
    
    .field.field--radio.mb-4
        label.block.text-sm.font-bold.mb-2(for="field") Radio
        .wrapper-radio
            input(type="radio" name="radio" value="radio-1")
            .ui-radio.flex.items-center
                .radio.flex.items-center.justify-center
                strong radio one

    .field.field--radio.mb-4
        .wrapper-radio
            input(type="radio" name="radio" value="radio-2")
            .ui-radio.flex.items-center
                .radio.flex.items-center.justify-center
                strong radio two

    .field.field--radio.mb-4
        .wrapper-radio.wrapper-radio--disabled
            input(type="radio" name="radio" value="radio-2" disabled)
            .ui-radio.flex.items-center
                .radio.flex.items-center.justify-center
                strong radio disabled

    .field.field--radio.mb-4
        .wrapper-radio.wrapper-radio--disabled
            input(type="radio" name="radio" value="radio-2" checked disabled)
            .ui-radio.flex.items-center
                .radio.flex.items-center.justify-center
                strong radio disabled checked

</template>

<script>
export default {
    name: 'formComponents'
}
</script>

<style lang="sass">
.field
    &--error
        color: #f35c51
        .field-style
            color: #f35c51
            border-color: #f35c51
            &:focus
                border-color: #f35c51
    &--disabled
        opacity: 0.4
        .field-style
            background: #e2e8f0
// .field-style
//     padding: 0rem .75rem
//     line-height: 40px
//     border-radius: .25rem
//     border: 1px solid #e2e8f0
//     color: #3d3d3d
//     background: #ffffff
    
//     &:focus
//         outline: none
//         border: 1px solid darken(#e2e8f0, 13%)

</style>
